import NavigationScroll from "../components/navigation";
import React from "react";

function ContactsPage() {
    return (
        <>
            <NavigationScroll/>
            <div className="page">

                <div className="container-center">
                    <div className="top-section">
                        <h1>Our Contacts</h1>
                    </div>
                    <div className="middle-section">
                        <h2>Vadim Chernov</h2>
                        <h2>+995 511175577</h2>
                        <h2>vad.chernov@gmail.com</h2>
                        <h2>info@iextrem.com</h2>
                        <h2>st Timiriazeva 16 51, 222164, Zhodino,  Belarus</h2>
                    </div>
                    <div className="bottom-section">

                        <h3>Whatever your need, we can solve IT.</h3>

                        <h5>Book a consultation through</h5>
                        <h5><a href="mailto:info@iextrem.com">info@iextrem.com</a></h5>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ContactsPage;
